<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Library"
                   :links="[{title:'Home', url:'/'},{title:'Library',url:'/about'},{title:'Notices'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="10"></sidebar>
        </section>
        <section class="content">
          <div class="flex heading-black1 justify-center uppercase font-serif">notices</div>
          <div class="space-y-8">
            <Notice v-for="(notice,index) in Notices" :key="index" :notice="notice"/>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/library/Sidebar";
import Programmes from "@/views/about/Programmes";
import Notice from '@/components/Notice'

export default {
  name: "Notices",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent, Notice
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      Notices: [
        {
          date: '24 March 2017',
          title: 'National Digital Library',
          description: 'We are happy to inform all the faculty staff and students, that Engineering Library is now a registered member of @(NDL) an initiative of MHRD,Govt.of India',
          file: 'Notice_NDL'
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.6rem;
}
</style>
